import { useAuthStore } from '@/stores/authStore'

/**
 * Custom hook for accessing authentication state and methods
 * Provides a clean interface to the auth store
 */
export const useAuth = () => {
  const store = useAuthStore()
  
  return {
    // State
    user: store.user,
    loading: store.loading,
    error: store.error,
    isAuthenticated: !!store.user,
    
    // Actions
    signIn: store.signIn,
    signUp: store.signUp,
    signInWithGoogle: store.signInWithGoogle,
    signOut: store.signOut,
    clearError: store.clearError,
  }
}

/**
 * Hook to get current user's auth token for API calls
 * Returns null if user is not authenticated
 */
export const useAuthToken = async (): Promise<string | null> => {
  const { user } = useAuthStore.getState()
  
  if (!user) {
    return null
  }

  try {
    // Import auth only when needed to avoid issues if not initialized
    const { auth } = await import('@/config/firebase')
    
    if (!auth?.currentUser) {
      return null
    }
    
    // Get fresh ID token
    const token = await auth.currentUser.getIdToken()
    return token
  } catch (error) {
    console.warn('Failed to get auth token:', error)
    return null
  }
}